import React from 'react';
import styled from 'styled-components';
import Checkbox from '@gr-monorepo/common/public/ui/Checkbox';
import { FONT_COLOR } from '@gr-monorepo/common/public/ui/constants/colors';
import Card from 'features/shared/ui/Card';
import {
  OlympiadStatus,
  olympiadStatusBgColor,
  olympiadStatusTextColor,
  olympiadStatusTranslate,
} from '../../models/Olympiad';
import { SidebarCardTitle } from '../../OlympiadsListStyled';

const FiltersCard = styled(Card).attrs({ $shadow: true, $padding: 24 })`
  display: flex;
  flex-direction: column;
`;

const FiltersTitle = SidebarCardTitle;

const FiltersList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

const StatusFilterItem = styled.label<{ $status: OlympiadStatus }>`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 16px;
  font-size: 16px;
  line-height: 20px;
  color: ${FONT_COLOR};
  border-radius: 16px;
  border: none;
  cursor: pointer;
  background-color: ${({ $status }) => olympiadStatusBgColor[$status]};
`;

type OlympiadsStatusFiltersProps = {
  availableStatuses: OlympiadStatus[];
  selectedStatuses: OlympiadStatus[];
  onToggle: (status: OlympiadStatus) => void;
};

const OlympiadsStatusFilters = ({
  availableStatuses,
  selectedStatuses,
  onToggle,
}: OlympiadsStatusFiltersProps) => (
  <FiltersCard data-testid="olympiads-status-filters">
    <FiltersTitle>Статус олимпиады</FiltersTitle>
    <FiltersList>
      {availableStatuses.map((status) => (
        <StatusFilterItem key={status} $status={status} data-testid={`olympiads-status-filter-${status}`}>
          <Checkbox
            checked={selectedStatuses.includes(status)}
            onChange={() => onToggle(status)}
            color={olympiadStatusTextColor[status]}
          />
          {olympiadStatusTranslate[status]}
        </StatusFilterItem>
      ))}
    </FiltersList>
  </FiltersCard>
);

export default OlympiadsStatusFilters;
